import React, { Fragment, useEffect, useState, useCallback } from 'react';
import Button from '@material-ui/core/Button';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';
import FormHelperText from '@material-ui/core/FormHelperText';
import Checkbox from '@material-ui/core/Checkbox';
import FormGroup from '@material-ui/core/FormGroup';
import AddIcon from '@material-ui/icons/Add';
import ClientAdd from './ClientAdd';
import Schedule from './Schedule';
import SearchInput from './../SearchInput';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { COLORS } from '../../styles/colors';
import ButtonContent from '../ButtonContent';
import LoadMoreIcon from './../LoadMoreIcon';
import Search from './../workouts/search';
import InfiniteScroll from 'react-infinite-scroll-component';
import { faTrash } from '@fortawesome/free-solid-svg-icons'
import { ConfirmJsMessage, paginationLimit } from './../../helpers.js';
import Modal from '@material-ui/core/Modal';
import ModalHeading from '../ModalHeading';
import moment from 'moment';

import _ from 'lodash';

const ScheduleMessageListing = props => {
	const {
		clientEmail,
        fetchScheduleMessages,
        deleteScheduleMessage,
        saveScheduleMessage,
        fetchScheduleMessageDetail,
        isMobile,
        isSent,
        updateMessagesCount
	} = props;

    const [massageList, setMessageList] = useState([]);
    const [isLoadMore, setLoadMore] = useState(false);
    const [isFetchRes, setFetchRes] = useState(false);
    const [isOpenEditMessageModal, setOpenEditMessageModal] = useState(false);
    const [message, setMessage] = useState(null);
    const [action, setAction] = useState('new');

	useEffect(() => {
       setFetchRes(false);
       setMessageList([])
	   fetchData(0)
	}, [clientEmail, isSent])

    const fetchData = (skip) => {
        fetchScheduleMessages({
            clientEmail,
            skip,
            limit: paginationLimit.TWENTY,
            isSent: isSent
        }).then((res) => {
            const data = Object.values(res.messages);
            let ranges = data[0]['data']
            const metadata = data[0]['metadata']
            if (skip !== 0) {
                ranges = [...massageList, ...ranges]
            }
            let total = 0;
            if (metadata.length && metadata[0]['total']) {
                total = metadata[0]['total'];
            }
            setFetchRes(true);
            setMessageList(ranges);
            setLoadMore(ranges.length < total)
            if (skip === 0) {
                updateMessagesCount(res)
            }

        })

    }

    const deleteMessageData = (id) => {
		if (ConfirmJsMessage(`Are you sure you want to delete this message?`)) {
			deleteScheduleMessage(id).then(() => {
                setMessageList([])
                setFetchRes(false);
				fetchData(0)
			});
		}
	}

    const renderDate = (date) => {
        return moment(date).utc(0, true).format('MMM YYYY');
    }

    const showEditActionMode = (message) => {
        setAction('edit');
        setOpenEditMessageModal(true)
        setMessage(message)
    }

    const onEditBodyMatrixClose = () => {
        setOpenEditMessageModal(false)
    }

    const updateMessage = (message) => {
        setOpenEditMessageModal(false)
        if (action === 'edit') {
            const findIndex = massageList.findIndex((r) => r._id === message._id);
            if (findIndex > -1) {
                massageList[findIndex] = message;
                setMessageList([...massageList]);
            }
        } else {
            setMessageList([])
            setFetchRes(false);
            fetchData(0)
        }
    }

    const addNewMessage = () => {
        setAction('new');
        setOpenEditMessageModal(true)
    }

    return (
        <Fragment>
            <div
					style={{
						marginTop: 25,
						display: 'flex',
					}}
				>
            <div style={{ marginBottom: 10, marginTop: 10 }}>
                { isOpenEditMessageModal && (
                    <Modal
                    className="modal show"
                    open={isOpenEditMessageModal}
                    onClose={() => { onEditBodyMatrixClose()}}
                    >
                    <div className="modalBody modal-content" style={{ width: isMobile ? '80%' : 700, minHeight: 500 }}>
                            <Fragment>
                                <ModalHeading
                                    text={ message ? `Edit Message` :  `New Message` }
                                    closeModal={() => { onEditBodyMatrixClose()}}
                                />
                                <div className="modalContent">
                                <Schedule
                                        isEdit={true}
                                        clientEmail = {clientEmail}
                                        isOpenAddModal = { true }
                                        message = {message}
                                        parentData = { updateMessage }
                                        hideActionModal = {() => {
                                            setOpenEditMessageModal(false)
                                        }}
                                        isMobile = {isMobile}
                                        user = { props.user}
                                        saveScheduleMessage = { saveScheduleMessage}
                                        fetchScheduleMessageDetail = { fetchScheduleMessageDetail }
                                        fetchScheduleMessages = { fetchScheduleMessages }
                                />
                                </div>
                            </Fragment>
                    </div>
                    </Modal>
                )}
                { !isSent  &&
                    <div style={{
                                marginTop: '5px',
                            }}>
                        <Button
                            color="primary"
                         
                            onClick={() => addNewMessage()}
                        >
                            <ButtonContent text="New Message" icon="plus"  />
                        </Button>
                    </div>
                }

                <div className="assign-scroll" id = "scrollableActions" style={{
                    width: isMobile ? '100%' : '800px',
                    overflow: 'auto',
					height: 350
                }}>
                            { (isFetchRes && massageList.length === 0 ) &&
                                <div style={{ textAlign: 'center', width: '750px' }}>
                                   <h1>No Message Available!</h1>
                                </div>
                            }
                            
                    <InfiniteScroll
                                    dataLength={massageList.length} //This is important field to render the next data
                                    next={() => fetchData(massageList.length)}
                                    hasMore={isLoadMore}
                                    scrollableTarget="scrollableActions"
                                    loader={
                                        <LoadMoreIcon/>
                                    }
                            >
                            {massageList.map(range => (
                                <Fragment>
                                    <div  style={{
                                        marginLeft: '2px',
                                        width: '700px'
                                    }}>
                                         <div
                                            className="link"
                                            style={{ 
                                               float: 'left',
                                               width: isMobile ? '200px': '400px', 
                                               display: 'block', 
                                               marginTop: '10px', 
                                               marginTop: '10px' }}
                                        >{ 
                                             range.message
                                          }
                                         </div>
                                         <div
                                            className="link"
                                            style={{ 
                                                float: 'left', 
                                                width: isMobile ? '200px': '200px', 
                                                display: 'block',  
                                                marginTop: '10px',
                                                marginTop: '10px' }}
                                        > { 
                                             `${range.selectDate} ${range.selectTime}`
                                          }
                                         </div>
                                         <div
                                            className="link"
                                            style={{ float: 'left', width: isMobile ? '200px': '100px', display: 'block',  marginTop: '10px', marginTop: '10px' }}
                                        >
                                         <span
                                            className="link"
                                            style={{ float: 'right' }}
                                            onClick={() => deleteMessageData(range._id)}
                                          >
                                            <FontAwesomeIcon icon={faTrash} title={'Delete'}
                                                style={{ marginRight: 5, color: COLORS.orange }} />
                                        </span>
                                        { !range.isSent &&
                                            <span
                                                className="link"
                                                style={{ float: 'right' }}
                                                onClick={() => showEditActionMode(range)}
                                            >
                                                <FontAwesomeIcon  icon="edit" title={'Edit Action'}
                                                    style={{ marginRight: 5, color: COLORS.orange }} />
                                            </span>
                                        }   
                                        </div>
                                       
                                    </div>
                                </Fragment>
                            ))}
                    </InfiniteScroll>
                </div>
            </div>
            </div>
        </Fragment>
    );
};

export default ScheduleMessageListing;



// WEBPACK FOOTER //
// ./src/components/assignments/ScheduleMessageListing.js